// AssetWithNetworkBadge.jsx
import React from 'react';

const AssetWithNetworkBadge = ({
  asset,
  getAssetImage,
  GettingNativeAsset,
  size = 'default', // 'small', 'default', 'large'
}) => {
  const sizeClasses = {
    small: {
      container: 'w-8 h-8 sm:w-10 sm:h-10',
      image: 'w-6 h-6 sm:w-8 sm:h-8',
      icon: 'w-4 h-4 sm:w-5 sm:h-5',
      badge: 'w-3 h-3 sm:w-3.5 sm:h-3.5',
      badgeIcon: 'w-2 h-2 sm:w-2.5 sm:h-2.5',
    },
    default: {
      container: 'w-10 h-10 sm:w-12 sm:h-12',
      image: 'w-8 h-8 sm:w-10 sm:h-10',
      icon: 'w-5 h-5 sm:w-6 sm:h-6',
      badge: 'w-3.5 h-3.5 sm:w-4 sm:h-4',
      badgeIcon: 'w-2.5 h-2.5 sm:w-3 sm:h-3',
    },
    large: {
      container: 'w-12 h-12 sm:w-16 sm:h-16',
      image: 'w-10 h-10 sm:w-14 sm:h-14',
      icon: 'w-6 h-6 sm:w-8 sm:h-8',
      badge: 'w-4 h-4 sm:w-5 sm:h-5',
      badgeIcon: 'w-3 h-3 sm:w-4 sm:h-4',
    },
  };

  const classes = sizeClasses[size];

  return (
    <div className={`relative ${classes.container}`}>
      {/* Main Asset Image */}
      <div
        className={`${classes.image} rounded-full bg-[#F9FAFB] border border-[#E9EAEB] flex items-center justify-center flex-shrink-0 overflow-hidden`}
      >
        {getAssetImage(asset) ? (
          <img
            src={getAssetImage(asset)}
            alt={asset.displayName}
            className={`${classes.icon} object-contain`}
            onError={(e) => {
              e.target.style.display = 'none';
              e.target.parentElement.innerHTML = `<span class="text-xs font-semibold text-[#6B7280]">${asset.displaySymbol.substring(
                0,
                2
              )}</span>`;
            }}
          />
        ) : (
          <span className="text-xs font-semibold text-[#6B7280]">
            {asset.displaySymbol.substring(0, 2)}
          </span>
        )}
      </div>

      {/* Network Badge Overlay */}
      {GettingNativeAsset(asset.legacyId)?.icon && (
        <div
          className={`absolute bottom-1.5 right-1.5 ${classes.badge} rounded-full bg-white border border-[#E9EAEB] flex items-center justify-center overflow-hidden shadow-sm`}
        >
          <img
            src={GettingNativeAsset(asset.legacyId).icon}
            alt={GettingNativeAsset(asset.legacyId).assetName}
            className={`${classes.badgeIcon} object-contain`}
            onError={(e) => {
              e.target.style.display = 'none';
            }}
          />
        </div>
      )}
    </div>
  );
};

export default AssetWithNetworkBadge;
